module.exports = __webpack_public_path__ + "media/images/all-care-benefits-form-34101a3f6302f7aa3ac9412da052154d.svg";